"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Page = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _shapes = require("./shapes");

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _CssBaseline = _interopRequireDefault(require("@material-ui/core/CssBaseline"));

var _reactDocumentTitle = _interopRequireDefault(require("react-document-title"));

var _Inner = _interopRequireDefault(require("./Inner"));

var _ProductThemeProvider = _interopRequireDefault(require("../ProductThemeProvider"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ThemeHelper = require("../Utilities/ThemeHelper");

var _withWidth = _interopRequireDefault(require("@material-ui/core/withWidth"));

var _cacheProvider = require("../Utilities/cache/cacheProvider");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Page = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Page, _Component);

  var _super = _createSuper(Page);

  function Page(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Page);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setOrganizationSettings", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var orgs, org;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.props.identityServerSdk.GetUsersOrganizations(null, null, null, null, _this.props.currentOrg);

            case 2:
              orgs = _context.sent;
              org = orgs.items.find(function (w) {
                return w.name.toString().toLowerCase() === _this.props.currentOrg.toLowerCase().trim();
              });

              if (org) {
                _this.setState({
                  organizationSettings: org
                });

                _cacheProvider.CacheProvider.getInstance().set(_cacheProvider.CacheProvider.CPP_ORG_CACHE_KEY, org);

                _this.props.onOrgSettingsRetrieved && setTimeout(function () {
                  return _this.props.onOrgSettingsRetrieved(org);
                }, 0);
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props = _this.props,
          product = _this$props.product,
          primaryHex = _this$props.primaryHex,
          currentOrgSettings = _this$props.currentOrgSettings,
          currentOrg = _this$props.currentOrg,
          type = _this$props.type,
          specificity = _this$props.specificity,
          title = _this$props.title,
          prefix = _this$props.prefix,
          cssReset = _this$props.cssReset;
      var orgSettings = currentOrgSettings || _this.state.organizationSettings;
      var orgName = _this.state.loading ? "Loading..." : currentOrg;
      var productTitle = (0, _ThemeHelper.getProductName)(product);
      var renderedTitle = title ? title : productTitle !== "Unknown product" ? productTitle : null;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        id: _this.props.id,
        className: "prmbl-page"
      }, /*#__PURE__*/_react.default.createElement(_CssBaseline.default, null), /*#__PURE__*/_react.default.createElement(_ProductThemeProvider.default, {
        product: product,
        specificity: specificity,
        primaryHex: type === "external" && orgSettings && orgSettings.settings.brandingSettings ? orgSettings.settings.brandingSettings.primaryColor || primaryHex : primaryHex,
        title: renderedTitle,
        prefix: prefix,
        cssReset: cssReset
      }, /*#__PURE__*/_react.default.createElement(_Inner.default, (0, _extends2.default)({}, _this.props, {
        currentOrgSettings: orgSettings,
        currentOrg: orgName,
        classes: undefined
      })))), renderedTitle ? /*#__PURE__*/_react.default.createElement(_reactDocumentTitle.default, {
        title: renderedTitle
      }) : null);
    });
    _this.state = {
      organizationSettings: null,
      loading: true
    };
    return _this;
  }

  (0, _createClass2.default)(Page, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var axe;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!(!this.props.currentOrgSettings && this.props.currentOrg && this.props.identityServerSdk)) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 4;
                return this.setOrganizationSettings();

              case 4:
                if (this.props.currentOrgSettings) {
                  _cacheProvider.CacheProvider.getInstance().set(_cacheProvider.CacheProvider.CPP_ORG_CACHE_KEY, this.props.currentOrgSettings);
                }

              case 5:
                _context2.prev = 5;
                this.setState({
                  loading: false
                });
                return _context2.finish(5);

              case 8:
                // Query string for accessibility testing - axe=on
                if (process.env.NODE_ENV !== "production") {
                  if (document.location.href.toLowerCase().includes("axe=on")) {
                    axe = require("react-axe"); // eslint-disable-line @typescript-eslint/no-var-requires

                    axe(_react.default, _reactDom.default, 1000);
                  }
                }

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0,, 5, 8]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }]);
  return Page;
}(_react.Component);

exports.Page = Page;
(0, _defineProperty2.default)(Page, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /**
   * See Account Menu Options belows.
   */
  accountMenuOptions: _propTypes.default.shape({
    includeDefault: _propTypes.default.bool,
    menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
      display: _propTypes.default.string.isRequired,
      action: _propTypes.default.func.isRequired
    })),
    show: _propTypes.default.bool,
    platformBaseUrl: _propTypes.default.string,
    signoutUrl: _propTypes.default.string
  }),

  /**
   * The current organization's name
   */
  currentOrg: _propTypes.default.string,

  /**
   * The current organization's branding settings
   */
  currentOrgSettings: _propTypes.default.shape({
    name: _propTypes.default.string,
    id: _propTypes.default.string,
    settings: _propTypes.default.object
  }),

  /**
   * What to do when the organization is selected.
   */
  onOrgSelect: _propTypes.default.func,

  /**
   * Called when organization settings are loaded.
   * This is useful for if you want to cache the organization settings to prevent
   * them from being re-pulled from the platform.
   */
  onOrgSettingsRetrieved: _propTypes.default.func,

  /**
   * The content of the Page
   */
  children: _propTypes.default.node,

  /**
   * If `true` the side bar will not be displayed
   */
  disableSidebar: _propTypes.default.bool,

  /**
   * If `true`, the top bar will not be displayed
   */
  disableTopbar: _propTypes.default.bool,

  /**
   * If `true`, the footer will not be displayed
   */
  disableFooter: _propTypes.default.bool,

  /**
   * The footer content
   */
  footerMessage: _propTypes.default.node,

  /**
   * See Navigation Sections below for more details
   */
  navigationSections: _shapes.NavigationSections,

  /**
   * See Product navagation sections below for more details
   */
  productNavSections: _shapes.ProductNavSections,

  /**
   * The identitySeverSdk object. Requires accessToken, identityServerBaseUrl, and idToken.
   * Used to get the user's products and information.
   *
   * If no user is specified, a blank product list will be shown and a user avatar will be hidden.
   */
  identityServerSdk: _propTypes.default.object,

  /**
   * See Help Menu Options belows.
   */
  helpMenuOptions: _propTypes.default.shape({
    menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
      display: _propTypes.default.string.isRequired,
      action: _propTypes.default.func.isRequired
    })),
    show: _propTypes.default.bool,
    signoutOfProduct: _propTypes.default.func
  }),

  /**
   * Sets product colors and logo automatically. Can be overridden by primaryHex and productLogo
   */
  product: _propTypes.default.oneOf(["engageCentral", "engageEvolve", "engage", "engage6", "hr", "clerk", "rec", "ready", "preamble"]),

  /**
   * The hex value for the product's primary color
   */
  primaryHex: _propTypes.default.string,

  /**
   * The html node to render as the product logo
   */
  productLogo: _propTypes.default.node,

  /**
   * @ignore
   *
   * Auto-populated by material-ui responsive helpers
   */
  width: _propTypes.default.string.isRequired,

  /**
   * The type of page, which affects what logo and color is used
   */
  type: _propTypes.default.oneOf(["internal", "external"]),

  /*
   * Disables the page's inner margin
   */
  disableMargin: _propTypes.default.bool,

  /*
   * @ignore
   *
   * Used for styleguide
   */
  forcePadding: _propTypes.default.bool,

  /**
   * How much extra specificty should be added to the JSS generated by Preamble
   */
  specificity: _propTypes.default.number,

  /**
   * Whether to include CSS resets for preamble styles. Useful in preventing conflicts in legacy applications.
   */
  cssReset: _propTypes.default.bool,

  /**
   * If `true` the menu will always collapse into a button, otherwise only on small screens
   */
  shouldCollapseMenu: _propTypes.default.bool,

  /**
   * Default Page Title when no Titlebar rendered. If not provided, falls back to one based on product
   */
  title: _propTypes.default.string,

  /**
   * Items to render in the topbar
   */
  customTopbar: _propTypes.default.node,

  /**
   * Props to pass to a NavigationRail. If present, will render a NavigationRail with these props. The sidebar must be disabled or set to always collapse before the NavigationRail will render.
   */
  navigationRailProps: _propTypes.default.object,

  /**
   * The prefix to generate classNames
   */
  prefix: _propTypes.default.string,

  /**
   * If `true` the product list will not render
   */
  disableProductList: _propTypes.default.bool
});
(0, _defineProperty2.default)(Page, "defaultProps", {
  navigationSections: {},
  productNavSections: [],
  accountMenuOptions: {
    includeDefault: true
  },
  type: "internal",
  shouldCollapseMenu: false
});

var _default = (0, _withWidth.default)()(Page);

exports.default = _default;